import React, { Component, Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { Typography, Grid } from '@material-ui/core';
import { VSpacer } from 'sm-react-components';

import AbstractPieChart from './AbstractPieChart';

const styles = {};

const strings = {
    optimizerV1: 'OptimizerV1',
    'optimizerV1-get': 'OptimizerV1-get',
    placesProfilerV1: 'PlacesProfilerV1'
};
class RequestPieChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            values: [],
            ...this.genState(props)
        };
    }

  genState = props => {
      const { statistics } = props;
      let counts = {};
      if (statistics === undefined || statistics.values === undefined) {
          return;
      }
      statistics.values.forEach(value => {
          Object.keys(value.requests || {}).forEach(key => {
              counts[key] = (counts[key] || 0) + value.requests[key];
          });
      });
      const values = Object.keys(counts).map(key => ({
          angle: counts[key],
          label: key,
          count: counts[key]
      }));
      return { values };
  };

  componentWillReceiveProps = props => {
      this.setState(this.genState(props));
  };

  render() {
      const { values } = this.state;
      const { width, withPercentage } = this.props;
      const sum = values.reduce((p, n) => p + n.count, 0);
      return (
          <Fragment>
              <Grid item md={width || 3} sm={12}>
                  <Typography variant="h5">Requests type</Typography>
                  <AbstractPieChart values={values} />
              </Grid>
              {withPercentage && (
                  <Grid item md={6}>
                      <Grid
                          container
                          direction="column"
                          justify="center"
                          style={{ height: '100%' }}
                      >
                          {values.map(v => (
                              <Fragment key={'fragment_' + v.label}>
                                  <Grid key={'globalgrid_' + v.label} item>
                                      <Grid key={'gridcontainert_' + v.label} container>
                                          <Grid key={'grid1_' + v.label} item lg={6}>
                                              <Typography key={'typ1_' + v.label} variant="h6">
                                                  {strings[v.label]}
                                              </Typography>
                                          </Grid>
                                          <Grid key={'grid2_' + v.label} item lg={6}>
                                              <Typography
                                                  key={'typ2_' + v.label}
                                                  variant="h6"
                                              >{`${Math.floor((v.count / sum) * 100)}%`}</Typography>
                                          </Grid>
                                      </Grid>
                                  </Grid>
                                  <VSpacer key={'spacer_' + v.label} medium />
                              </Fragment>
                          ))}
                      </Grid>
                  </Grid>
              )}
          </Fragment>
      );
  }
}

export default withStyles(styles)(RequestPieChart);
